import {
  useGetBannerQuery,
  type ContentManagementFlyoutPlacement,
  type ContentManagementUnknownBannerPlacement,
  type ContentManagementHeroBannerPlacement,
  type ContentManagementSecondaryBannerPlacement,
} from 'domains/banners/api'
interface BannerArgs {
  placementId: string
}

export const useGetQueryBanner = ({ placementId }: BannerArgs) => {
  const { data, error, loading } = useGetBannerQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      placementId,
    },
  })

  return {
    apiResult: data?.homePlacementSearch[0] as
      | ContentManagementUnknownBannerPlacement
      | ContentManagementHeroBannerPlacement
      | ContentManagementSecondaryBannerPlacement
      | ContentManagementFlyoutPlacement,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiError: error,
  }
}
